import { useEffect, useRef, useState } from "react";
import { WarehouseDetailsViewModel } from "../../../viewmodels/setup/warehouses/WarehouseDetailsViewModel";

import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";

import { withRouter } from "../../../shared/utility";

import SlideOver from "../../../components/slideOver/SlideOver";
import EmptyModal from "../../../components/modals/EmptyModal";

import SimpleNotification from "../../../components/SimpleNotification";
import AuditActionLink from "../../../components/audit/AuditActionLink";

import { useParams } from "react-router-dom";

function WarehouseDetails(props) {
  const { logout } = props;

  const { warehouseId } = useParams();

  const {
    getWarehouseDetails,
    loading,
    warehouse,
    setSlideOver,
    slideOver,
    locations,
    setShowSimpleNotification,
    showSimpleNotification,
    setEmptyModelOpen,
    emptyModal,
    openAddLocationSlideOver,
    getWarehouseLocations,
    askDeleteLocation,
  } = WarehouseDetailsViewModel(logout, warehouseId);

  useEffect(() => {
    getWarehouseDetails();
    getWarehouseLocations();
  }, []);

  return (
    <div>
      <SimpleNotification
        setShow={setShowSimpleNotification}
        showSimpleNotification={showSimpleNotification}
      />
      <div className="mt-2 px-4 sm:px-8">
        <div className="sm:items-center">
          <div className="sm:flex sm:items-center sm:justify-between sm:flex-auto">
            <h1 className="text-2xl font-semibold leading-6 text-gray-900">
              {warehouse.name}
            </h1>
            {warehouse.id != null && (
              <AuditActionLink
                slug="warehouse"
                id={warehouse.id}
                name={warehouse.name}
              />
            )}
          </div>
          {/* <div className="mt-5">
            <WarehouseDetailsForm warehouse={warehouse} />
          </div> */}
          <div className="px-4 py-5 sm:px-4 card-custom mt-5">
            <div className="sm:flex sm:items-center">
              <div className="flex flex-grow">
                <h1 className="text-base font-semibold leading-6 text-gray-900 flex-grow">
                  Locations
                </h1>
                <button
                  type="button"
                  className="ml-5 rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  onClick={() => openAddLocationSlideOver(false, null, null)}
                >
                  Add location
                </button>
              </div>
            </div>
            <div className="inline-block min-w-full py-2 align-middle">
              {loading ? (
                <div>
                  <div className="border h-10 shadow rounded-md p-4 w-full mx-auto">
                    <div className="animate-pulse flex space-x-4">Loading</div>
                  </div>
                </div>
              ) : (
                <div className="overflow-hidden">
                  <table className="min-w-full divide-y divide-gray-300">
                    <thead className="bg-white">
                      <tr>
                        <th
                          scope="col"
                          className="py-3 pr-3 text-left text-sm font-semibold text-gray-900"
                        >
                          Name
                        </th>
                        <th
                          scope="col"
                          className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                        ></th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {locations.data.length === 0 ? (
                        <tr>
                          <td className="whitespace-nowrap py-1.5 pr-3 text-sm font-medium text-gray-500">
                            No locations, please add one
                          </td>
                        </tr>
                      ) : (
                        locations.data.map((location, index) => (
                          <tr key={location.id}>
                            <td className="whitespace-nowrap py-1.5 pr-3 text-sm font-medium text-gray-500">
                              {location.name}
                            </td>
                            <td className="relative whitespace-nowrap py-1.5 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                              <button
                                className="ml-2 rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                onClick={() =>
                                  openAddLocationSlideOver(
                                    true,
                                    location,
                                    index
                                  )
                                }
                              >
                                Edit
                              </button>
                              <button
                                onClick={() => {
                                  askDeleteLocation(warehouse, index);
                                }}
                                className="ml-2 rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                              >
                                Delete
                              </button>
                              <AuditActionLink
                                slug="warehouse-location"
                                id={location.id}
                                name={location.name}
                              />
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WarehouseDetails)
);
